import { render } from "./HelpPopover.vue?vue&type=template&id=3feaa443&scoped=true&lang=pug"
import script from "./HelpPopover.vue?vue&type=script&lang=js"
export * from "./HelpPopover.vue?vue&type=script&lang=js"

import "./HelpPopover.vue?vue&type=style&index=0&id=3feaa443&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3feaa443"]])

export default __exports__